export function ghIsNaN() {
  return (input: number) => !isNaN(input);
}
